module.exports = __webpack_public_path__ + "img/main_3.2ec2ec02.jpg";